import { defineComponent as _defineComponent } from 'vue'
import {
    HouseDesignInterface,
    HouseLotsBuilderPagination,
    HouseWithLotsAndBuilder,
  } from "@/types/HouseDesignInterface";
  import HouseCard from "./HouseCard.vue";
  import { EstateInterface } from "@/types/EstateInterface";
  import { BuilderQuote } from "@/types/BuilderQuote";
  import { BorrowCalculatorResult } from "@/types/BorrowCalculator";
  import { ref, watch } from "vue";
  import { useIsDesktop } from "@/features/useIsDesktop";

  const smallLayoutWidth = 990;
  const INITIAL_DISPLAYED_HOUSES = 6;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ListHouses',
  props: {
    houses: {},
    estate: {},
    quote: {},
    result: {},
    houseDetailsView: { type: Boolean },
    nextBatch: {}
  },
  emits: ["onClickHouse", "loadNextBatch"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;

  const { isDesktop } = useIsDesktop(smallLayoutWidth);

  const loading = ref(true);
  const hasNextBatch = ref(false);
  const displayedHouses = ref<HouseDesignInterface[]>([]);

  const onClickHouse = (lotId?: string) => emit("onClickHouse", lotId);

  watch(
    () => props.houses,
    (newHouses) => {
      if (newHouses) {
        loading.value = false;
        displayedHouses.value = newHouses.slice(0, INITIAL_DISPLAYED_HOUSES);
      }
    },
    { immediate: true }
  );

  const loadMoreHouses = (nextBatch: HouseLotsBuilderPagination) => {
    displayedHouses.value = [
      ...displayedHouses.value,
      ...(nextBatch.data ?? []),
    ];
  };

  const setNextBatchData = (nextBatch?: HouseLotsBuilderPagination) => {
    if (nextBatch) {
      hasNextBatch.value = nextBatch.hasNextPage;
    }
  };

  const loadMoreHousesIfNextBatch = (
    nextBatch?: HouseLotsBuilderPagination
  ) => {
    if (nextBatch && nextBatch.page > 1) {
      loading.value = false;
      loadMoreHouses(nextBatch);
    }
  };

  watch(
    () => props.nextBatch,
    (nextBatch) => {
      setNextBatchData(nextBatch);
      loadMoreHousesIfNextBatch(nextBatch);
    },
    { immediate: true }
  );

  const loadMore = () => {
    loading.value = true;
    emit("loadNextBatch");
  };

const __returned__ = { props, emit, smallLayoutWidth, isDesktop, INITIAL_DISPLAYED_HOUSES, loading, hasNextBatch, displayedHouses, onClickHouse, loadMoreHouses, setNextBatchData, loadMoreHousesIfNextBatch, loadMore, get HouseDesignInterface() { return HouseDesignInterface }, get HouseLotsBuilderPagination() { return HouseLotsBuilderPagination }, get HouseWithLotsAndBuilder() { return HouseWithLotsAndBuilder }, HouseCard, get EstateInterface() { return EstateInterface }, get BuilderQuote() { return BuilderQuote }, get BorrowCalculatorResult() { return BorrowCalculatorResult }, ref, watch, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})